module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("mt-input mt-input--" + (_vm.valid ? 'valid' : 'invalid') + " " + (_vm.disabled ? 'mt-input--disabled': '')),
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('label', {
    on: {
      "mouseover": function($event) {
        _vm.isHover = true
      },
      "mouseleave": function($event) {
        _vm.isHover = false
      }
    }
  }, [_c('span', {
    staticClass: "mt-input__label mt-font--caption20 mt--neutrals-dark-gray-02"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    staticClass: "mt-font--body10",
    style: ({
      width: _vm.width + 'px'
    }),
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.selfModel
    },
    on: {
      "keyup": _vm.handleInputChange,
      "focus": _vm.handleInputFocus,
      "click": _vm.handleInputClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'textarea') ? _c('textarea', {
    staticClass: "mt-font--body10",
    style: ({
      width: _vm.width + 'px'
    }),
    domProps: {
      "value": _vm.selfModel
    },
    on: {
      "focus": _vm.resizeTextarea,
      "keyup": _vm.resizeTextarea
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.valid) ? _c('span', {
    staticClass: "mt-input__invalid-msg mt--bg--error mt--white mt-font--caption10",
    style: ({
      width: _vm.width + 'px'
    })
  }, [_vm._v("\n      Lorem ipsum dolor sit amet, consectetur\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "mt-input__caption mt-font--caption10 mt--neutrals-dark-gray-01",
    style: ({
      width: _vm.width + 'px'
    })
  }, [_vm._v(_vm._s(_vm.caption))]), _vm._v(" "), (_vm.clearble && _vm.selfModel.length > 0) ? _c('mt-icon', {
    staticClass: "mt-input__clearble",
    style: (_vm.clearbleStyle),
    attrs: {
      "iconName": "close-circle"
    },
    on: {
      "click": _vm.handleClickClear
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('mt-icon', {
    staticClass: "mt-input__icon",
    style: ({
      top: _vm.label ? '30px' : '11px'
    }),
    attrs: {
      "iconName": _vm.icon
    },
    on: {
      "click": _vm.handleClickIcon
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be627e1","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/input/Input.vue
// module id = vQY4
// module chunks = 0